import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth/auth.service";

//TODO does portal handles locked out accounts?
@Component({
    selector: 'app-lockedout',
    templateUrl: './lockedout.component.html',
    styleUrls: ['./lockedout.component.css'],
    standalone: false
})
export class LockedoutComponent implements OnInit {

    constructor(private authService: AuthService) {
    }

    ngOnInit(): void {
        this.authService.startSessionPolling();
        this.authService.startSessionExpiryWatcher();
    }

    ngOnDestroy() {
        this.authService.stopSessionExpiryWatcher();
    }

}
